<template>
    <div class="min-h-screen flex flex-col ">
        <router-view />
    </div>
</template>

<script>


export default {
    name: 'EmptyLayout',
    components: {
  
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {

    },
    computed: {

    },
    created(){

    }
}

</script>